module.exports = __webpack_public_path__ + "static/img/kcc-short-introduction.252eb036.jpg";